WiseMetering.Views.EditCompany = WiseMetering.Views.Modal.Save.extend({
    template: 'templates/companies/edit',
    className: 'mbx-info text-left',
    form_prefix: 'company',
    title: () => i18next.t('modal.title.companies.edit')
});
